import { LocaleCode, LocaleCodeMap } from '@doss/common-all'
import { useFormikContext } from 'formik'
import { DataType } from '~/common/generated/apollo-operations'
import { useGlobalContext } from '~/common/hooks/useGlobalContext'
import { DateFormatFields, DateFormatValue } from '~/components/date-format/DateFormatFields'
import { ColumnFormValues } from './types'

/**
 * Formik adapter for table column date formatting. Bridges the shared, form-library-agnostic
 * {@link DateFormatFields} to Formik's `formatPreset`/`formatOptions` fields.
 */
export const DateFormatSection = () => {
  const { user } = useGlobalContext()
  const orgLocale = user?.organizationLocale
    ? LocaleCodeMap[user.organizationLocale]
    : LocaleCode.EN_US
  const formik = useFormikContext<ColumnFormValues>()
  const isDateTime = formik.values.type === DataType.DATE_TIME

  const onChange = ({ formatPreset, formatOptions }: DateFormatValue) => {
    formik.setValues((current) => ({ ...current, formatPreset, formatOptions }))
  }

  return (
    <DateFormatFields
      formatOptions={formik.values.formatOptions}
      formatPreset={formik.values.formatPreset}
      isDateTime={isDateTime}
      onChange={onChange}
      orgLocale={orgLocale}
    />
  )
}
